export default __webpack_public_path__ + "static/media/cara-kerja-4.ab200ca3.png";